import ReactMarkdown from "react-markdown";

type MarkdownFieldProps = {
  value?: string;
};

export const MarkdownField = ({ value = "" }: MarkdownFieldProps) => {
  return <ReactMarkdown>{value}</ReactMarkdown>;
};
